import React, { Component } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { Tabs } from "antd";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { Container } from "@material-ui/core";
import { TextShow } from "../Essentials/TextShow";
import NotificationDescription from "../Notifications/NotificationDescription";

class InternshipDescription extends Component {
  render() {
    return (
      <div style={{ marginTop: "" }}>
        {this.props.type == "why-dispur-college" ? <TextShow title="Why Dispur College" type="DISPUR_COLLEGE" /> : null}
        {this.props.type == "pillars-of-strength" ? <TextShow title="Pillars of Strength" type="PILLARS_STRENGHT" /> : null}
        {this.props.type == "course-overview" ? <TextShow title="Course Overview" type="COURSE_OVERVIEW" /> : null}
        {this.props.type == "internship-procedure" ? <TextShow title="Internship Procedure" type="INTERNSHIP_PROCEDURE" /> : null}
        {this.props.type == "ipo-registration-form" ? <div>
          <BreadCrumbOwn title="IPO Registration Form" />
          <NotificationDescription title="IPO Registration Form" code="IPO_REGISTRATION" /></div> : null}
        {this.props.type == "our-collaborations" ? <div>
          <BreadCrumbOwn title="Our Collaborations" />
          <NotificationDescription title="Our Collaborations" code="COLLABORATIONS" /></div> : null}
        {this.props.type == "past-ipos" ? <div>
          <BreadCrumbOwn title="Past IPOs" />
          <NotificationDescription title="Past IPOs" code="PAST_IPOS" /></div> : null}
        {this.props.type == "stories-of-success" ? <div>
          <BreadCrumbOwn title="Stories of Success" />
          <NotificationDescription title="Stories of Success" code="STORIES_OF_SUCCESS" /></div> : null}
       
       </div>
    );
  }
}

export default InternshipDescription;

export const About = (props) => {
  return (
    <div>
      <BreadCrumbOwn title="About College" />
      <Container className="mb-5">
        <Typography
          variant="h4"
          style={{ margin: "1em 0", fontWeight: 700 }}
          gutterBottom
        >
          {props.title}
        </Typography>

        {/* <Typography
                variant="h6"
                gutterBottom
            >
                History
            </Typography> */}

        <Typography variant="body1" gutterBottom>
          The Mahavidyalaya was established at Eraligool in the district of
          Sribhumi on 1st September 2017 by the Government of Assam with the
          financial assistance from the Rashtriya Uchchatar Shiksha Abhiyan
          (RUSA). It is the first and only Government Model Degree College in
          the Barak Valley dedicated to Science education. The institution is
          named after Internship and Apprenticeship cell, Dispur College Upadhyaya, a great thinker, philosopher
          and renowned sociologist of the country. The objective behind the
          government initiative to establish this Mahavidyalaya is to provide
          quality higher education along with a distinct focus on Science
          education which is affordable and accessible to all sections of the
          society. The Mahavidyalaya, which came into existence through
          continuous efforts of the Department of Higher Education and the RUSA,
          had finally been able to open the gate of higher education to the
          first batch of students from the academic session 2017-2018.
        </Typography>
        <Typography variant="body1" gutterBottom>
          The Mahavidyalaya is affiliated to Assam University, Silchar and
          offers the core subjects such as Physics, Chemistry, Mathematics,
          Botany, Zoology and Statistics along with English and Bengali. Honours
          Courses are also available in all the subjects, except English and
          Bengali. The Mahavidyalaya also offers Higher Secondary courses in
          Science stream under the Assam Higher Secondary Education Council
          (AHSEC). Started with a very few copies of books in the library, now
          the Mahavidyalaya has a holding of over 5,000 collections of both
          textbooks and references in its Central Library. Steps have been taken
          to subscribe to journals of different disciplines. To expand academic
          dimension of the Mahavidyalaya, introduction of several Skill
          Development and job-oriented courses are in the pipeline. A galaxy of
          highly qualified, energetic, and dedicated faculties along with
          Non-Teaching staff put their best efforts to impart education
          following learner-centered approach and participatory methods along
          with continuous monitoring of students for their overall improvement.
        </Typography>
        <Typography variant="body1" gutterBottom>
          Situated at Eraligool, a very beautiful and mesmerizing tiny hamlet
          with its sylvan background, the Mahavidyalaya is about 26 kms from the
          District Headquarters of Sribhumi. The Mahavidyalaya has an
          infrastructure built on a sprawling campus spreading over 30 bighas of
          land. The serene and tranquil campus of the Mahavidyalaya offers the
          best of ambience including well-stocked library, digital classrooms,
          and state of the art laboratories conducive for teaching, learning and
          research along with residential facilities for teaching and
          non-teaching staff and girl students. Although the infrastructure of
          the Mahavidyalaya is under progress, it is expected that it will be
          completed soon by the sincere efforts of the concerned authorities.
        </Typography>
        <br />
        {/* <Typography variant="body1" gutterBottom>
          Situated on the western bank of the Bharalu, a rivulet, in the western part of Guwahati, Internship and Apprenticeship cell, Dispur College . is about 1 kilometre away from its confluence with the mighty Brahmaputra. It is about 4 kilometres from the Guwahati Railway Station and at a distance of about 20 kilometres from the Lokapriya Gopinath Bordoloi International Airport. At the backdrop of the college is a beautiful panoramic view of Nilachal Hills, the famous abode of Mother Goddess Kamakhya.
        </Typography>
        <br />
        <Typography variant="body1" gutterBottom>
          In the emblem of the college, is ingrained the motto “तेजस्विनावधीतमस्तु” (May our study make us illumined)and a conch shell at the centre on an eight-petalled full-blown beautiful-lotus, which symbolizes pure knowledge and the relationship between the teacher and the learner, praying to the Almighty for energy, protection, maintenance that ultimately leads to peace and bliss.
        </Typography>
        <br />
        <Typography variant="body1" gutterBottom>
          In its glorious existence of six decades, Internship and Apprenticeship cell, Dispur College ., as alma mater, has produced a galaxy of eminent personalities in all walks of life. The college celebrated its Diamond Jubilee Year during 2013–14.
        </Typography> */}
      </Container>
    </div>
  );
};

export const History = (props) => {
  return (
    <div>
      <Typography
        variant="h4"
        style={{ margin: "1em 0", fontWeight: 700 }}
        gutterBottom
      >
        {props.title}
      </Typography>

      {/* <Typography
                variant="h6"
                gutterBottom
            >
                History
            </Typography> */}

      <Typography variant="body1" gutterBottom>
        The Internship and Apprenticeship Cell, Dispur College (IAC–DC), was
        formally constituted on 26 February 2025 (Notification No.
        DC/IAC-DC/2025/930 dated 27.02.2025, issued by the Office of the
        Principal) with the objective of enabling a seamless transition of
        students from academic learning to professional engagement. Established
        under the leadership of Mr. Sutibra Malakar as its first Coordinator,
        the Cell is committed to enhancing student employability through skill
        development, industry exposure, and structured experiential learning. It
        facilitates internships and apprenticeships for students in external
        organisations while also offering structured in-house opportunities.
      </Typography>
      <Typography variant="body1" gutterBottom>
        The Cell functions as the central coordinating body for all internship
        and apprenticeship activities of the College and is organised into two
        primary divisions: the Internship Division and the Apprenticeship
        Division. It works in close collaboration with academic departments,
        regulatory authorities, and a wide range of external
        organisations—including government agencies, public sector undertakings
        (PSUs), industries, corporations, companies, businesses, enterprises,
        non-governmental organisations (NGOs), and skilling and training
        agencies—to ensure that students gain meaningful, curriculum-aligned
        practical experience. The Cell also oversees the necessary approval and
        documentation processes associated with these engagements.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Dispur College is a registered establishment under the National
        Apprenticeship Training Scheme (NATS) (Establishment ID: EASKMS106480),
        under the aegis of the Board of Practical Training (Eastern Region)
        [BOPT (ER)], through which the College regularly engages apprentices.
      </Typography>
      <Typography variant="body1" gutterBottom>
        The Cell actively fosters institutional linkages to expand opportunities
        for internships and apprenticeships, including through Memoranda of
        Understanding (MoUs), and organises orientation and awareness programmes
        to encourage and support student participation.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Through its initiatives, the Internship and Apprenticeship Cell strives
        to promote practical learning, professional competence, and career
        readiness among students.
      </Typography>
    </div>
  );
};

export const Vission = (props) => {
  return (
    <div>
      <BreadCrumbOwn title="Motto, Vision & Mission" />
      <Container className="mb-5">
        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          Motto
        </Typography>

        <Typography variant="body1" gutterBottom>
          तेजस्विनावधीतमस्तु
          <br />
          Tejasvinavadhitamastu
          <br />
          (May our study make us illumined)
        </Typography>

        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          Vision
        </Typography>

        <Typography variant="body1" gutterBottom>
          To fulfill the visionary aspirations of the regional youth segment
          through a process of vibrant and continuous innovations and
          initiatives in multiple spheres of academic as well as professional
          development, leading to the fullest realisation of the potential of
          the students.
        </Typography>

        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          Mission
        </Typography>

        <Typography variant="body1" gutterBottom>
          <p>
            <ul>
              <li>
                To make teachers and the taught partners in the learning
                process.
              </li>
              <li>
                To promote a student friendly atmosphere for encouraging them to
                be self-reliant and self-employable.
              </li>
              <li>
                To promote extra-curricular activities simultaneously with
                curricular activities.
              </li>
              <li>
                To mould the students into socially conscious human beings.
              </li>

              <li>
                To encourage students to think globally and act locally as
                productive citizens, through the promotion of scientific temper
                and action.
              </li>
              <li>
                To foster and inculcate moral and spiritual accomplishments
                amongst the students.
              </li>
              <li>To develop a transparent and responsive administration.</li>
              <li>
                To undergo self-analysis and self-discovery leading to
                elimination of bottlenecks in the context of a holistic
                framework
              </li>
            </ul>
          </p>
        </Typography>
      </Container>
    </div>
  );
};

const { TabPane } = Tabs;

export const ICV = (props) => {
  return (
    <div>
      <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
        {props.title}
      </Typography>

      <Typography variant="body1" gutterBottom>
        <p>
          <ol>
            <li>
              The Primary aim of the college is to prepare students academically
              for Higher Secondary and Degree Examination.{" "}
            </li>
            <li>
              To produce efficient human resource for serving for the betterment
              of the district in particular and to act as a conscious citizen in
              general.{" "}
            </li>

            <li>To spread higher education in the district.</li>
          </ol>
        </p>
      </Typography>
    </div>
  );
};

export const Emblem = (props) => {
  return (
    <div>
      <BreadCrumbOwn title="Emblem" />
      <Container className="mb-5">
        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          {props.title}
        </Typography>

        <div>
          <img
            src="/images/prag-logo-small.png"
            style={{ width: 200, marginBottom: 20 }}
          />
        </div>

        <Typography variant="body1" gutterBottom>
          The conch on the eight-petaloid full-bloomed graceful lotus symbolises
          pure knowledge.तेजस्विनावधीतमस्तु (Tejasvinavadhitamastu), the
          inspiring Motto of our college, speaks: May our study make us
          illumined. The aims, objectives and ideals of education are epitomised
          in this great saying of Taittiriya Upanishad (Ch. II Brahmananda
          Valli, Section 1, Invocation).
        </Typography>
      </Container>
    </div>
  );
};
